module.exports = __webpack_public_path__ + "static/media/portrait.f007d249.webp";